import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import logo from "../assets/images/logo/online-logo.png";
import MobileMenu from "./MobileMenu";
import { useTranslation } from "react-i18next";
import i18n from "../i18n";

const Header = () => {
  const [activeMobileMenu, setActiveMobileMenu] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const scrollNav = useRef(null);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      if (scrollNav.current) {
        const windowScroll = window.scrollY > 100;
        scrollNav.current.classList.toggle("rt-sticky-active", windowScroll);
        scrollNav.current.classList.toggle("sticky", windowScroll);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const { t } = useTranslation();
  const currentLang = i18n.language;

  const languages = [
    { code: "en", name: "English" },
    { code: "ar", name: "العربية" },
  ];

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng).then(() => {
      document.documentElement.lang = lng;
      document.documentElement.dir = lng === "ar" ? "rtl" : "ltr";
      setIsDropdownOpen(false);
    });
  };

  const isActive = (path) => location.pathname === path;

  return (
    <>
      <header
        className="site-header home-one-header top-0 w-full z-[999] rt-sticky"
        ref={scrollNav}
      >
        <div className="main-header py-6">
          <div className="container">
            <div className="flex items-between justify-between">
              <Link
                to="/"
                className="brand-logo flex-none lg:mr-10 md:w-auto max-w-[120px]"
              >
                <img src={logo} alt="logo" />
              </Link>

              <div className="flex items-center justify-between m-8 gap-4">
                <div className="flex-1 main-menu relative mr-[74px]">
                  <ul className="menu-active-classes flex space-x-6">
                    <li>
                      <Link
                        to="/"
                        className={
                          isActive("/") ? "text-primary font-bold" : ""
                        }
                      >
                        {t("nav.home")}
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/about"
                        className={
                          isActive("/about") ? "text-primary font-bold" : ""
                        }
                      >
                        {t("nav.about_us")}
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/service"
                        className={
                          isActive("/service") ? "text-primary font-bold" : ""
                        }
                      >
                        {t("nav.services")}
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/special-needs"
                        className={
                          isActive("/special-needs")
                            ? "text-primary font-bold"
                            : ""
                        }
                      >
                        {t("nav.special_needs")}
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/blogs"
                        className={
                          isActive("/blogs") ? "text-primary font-bold" : ""
                        }
                      >
                        {t("nav.blogs")}
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/contacts"
                        className={
                          isActive("/contacts") ? "text-primary font-bold" : ""
                        }
                      >
                        {t("nav.contacts")}
                      </Link>
                    </li>
                  </ul>
                </div>

                <div className="flex-none flex space-x-[26px]">
                  <div className="block lg:hidden">
                    <button
                      type="button"
                      className="text-3xl md:w-[56px] h-10 w-10 md:h-[56px] rounded bg-[#F8F8F8] flex flex-col items-center justify-center menu-click"
                      onClick={() => setActiveMobileMenu(!activeMobileMenu)}
                    >
                      <iconify-icon icon="cil:hamburger-menu" rotate="180deg" />
                    </button>
                  </div>
                </div>

                <div className="relative m-8 mx-[10px]">
                  <button
                    onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                    className="border px-4 py-2 rounded btn btn-primary flex items-center gap-2"
                  >
                    {languages.find((lang) => lang.code === currentLang)?.name}
                    <iconify-icon
                      icon="ion:chevron-down"
                      className="text-xl transition-transform"
                      style={{
                        transform: isDropdownOpen
                          ? "rotate(180deg)"
                          : "rotate(0deg)",
                      }}
                    ></iconify-icon>
                  </button>

                  {isDropdownOpen && (
                    <div className="absolute right-0 mt-2 w-40 bg-white shadow-lg rounded-md overflow-hidden z-50">
                      {languages.map((lang) => (
                        <button
                          key={lang.code}
                          onClick={() => changeLanguage(lang.code)}
                          className={`block w-full px-4 py-2 text-left hover:bg-gray-100 ${
                            currentLang === lang.code
                              ? "bg-gray-300 font-bold"
                              : ""
                          }`}
                        >
                          {lang.name}
                        </button>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>

      {activeMobileMenu && (
        <MobileMenu
          activeMenu={activeMobileMenu}
          setActiveMenu={setActiveMobileMenu}
        />
      )}
    </>
  );
};

export default Header;
